import React, { Component } from "react";
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import { TextField, InputBase, InputAdornment, IconButton, Select, MenuItem, FormControl, FormHelperText, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import desc from '../../../../assets/img/svg/desc.svg';
import { useNavigate } from "react-router-dom";
import Autocomplete from "react-autocomplete"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery"
import { addMOM, getMOM_Materials } from "../../../../actions/MOMAction";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import del from "../../../../assets/img/svg/Del.svg"

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
}));

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}


class AddDROHM extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            ProjectId: 0,
            Error: {
                DeliveryError: false,
                MaterialError: false,
                TotalError: false,
            },
            cancel: false,
            addData: {
                ProjectId: 0,
                Material: '',
                TotalQuantity: '',
                ReusedInMT: '',
                RecycledInMT: '',
                LandFillInMT: '',
                Delivery: '',
                ModifiedBy: ""
            },
            isMobile: false,
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        dispatch(getMOM_Materials())
        dispatch(getlookupdocinfo("Matrix"))
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#MAT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Matrix1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Matrix").addClass("d-none");
        $("#Matrix").removeClass("d-block");
        $("#MOML").removeClass("active-color");
        $("#MOMT").removeClass("fw-bolder");
    }
    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/matrixofmaterials`)
        }
    }
    AddCancel = () => {
        window.$("#cancelpopup").modal("hide");
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/matrixofmaterials")
    };
    AddSave = () => {
        const { dispatch } = this.props;
        const { Material, TotalQuantity, ReusedInMT, RecycledInMT, LandFillInMT, Delivery } = this.state.addData;
        if (Material.trim() === "") {
            this.state.Error.MaterialError = true;
            this.state.addData.Material = this.state.addData.Material.trim();
            this.setState({})
        }
        else {
            this.state.Error.MaterialError = false;
            this.state.addData.Material = this.state.addData.Material.trim();
            this.setState({})
        }
        if (Delivery.trim() === "") {
            this.state.Error.DeliveryError = true;
            this.state.addData.Delivery = this.state.addData.Delivery.trim();
            this.setState({})
        }
        else {
            this.state.Error.DeliveryError = false;
            this.state.addData.Delivery = this.state.addData.Delivery.trim();
            this.setState({})
        }
        if (TotalQuantity === "" || TotalQuantity === 0) {
            this.state.Error.TotalError = true;
            this.setState({})
        }
        else {
            this.state.Error.TotalError = false;
            this.setState({})
        }
        if (this.state.addData.Material !== '' && this.state.addData.Delivery !== '' && this.state.Error.TotalError != true) {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (ReusedInMT == '') {
                this.state.addData.ReusedInMT = 0;
                this.setState({})
            }
            if (RecycledInMT == '') {
                this.state.addData.RecycledInMT = 0;
                this.setState({})
            }
            if (LandFillInMT == '') {
                this.state.addData.LandFillInMT = 0;
                this.setState({})
            }
            this.addMOM(this.state.addData)
            const adddata = {
                ProjectId: 0,
                Material: '',
                TotalQuantity: '',
                ReusedInMT: '',
                RecycledInMT: '',
                LandFillInMT: '',
                Delivery: '',
            }
            this.state.addData = adddata;
            this.setState({})
        }

    }
    addMOM = (data) => {
        let apiUrl = API.MOM_LISTVIEW;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/matrixofmaterials")
                    //dispatch({ type: "OPA_Add", data: response.data })
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"))
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

    };
    resize1 = () => {
        $("#MAT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Matrix1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Matrix").removeClass("d-none");
        $("#Matrix").addClass("d-block");
        $("#MOML").addClass("active-color");
        $("#MOMT").addClass("fw-bolder");
    }
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSearchChange = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Material = e.target.value;
        this.setState({});
    };
    handleProjectNameSelectChange = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData.Material = e;
        this.setState({});
    };
    handleStringChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData[node] = e.target.value;
        this.setState({});
    };
    handleInputChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        if (e.target.value == '') {
            this.state.addData[node] = ''
            this.setState({});
        }
        else {
            this.state.addData[node] = parseFloat(e.target.value)
            this.setState({});
        }
    };
    render() {
        let { classes, menuToggle, MASTERDATA_MATERIAL } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-4 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"MAT" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="MAT" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className=" col-6 pt-3 mt-5">
                                    <h4>Add New Matrix Of Materials-Disposition</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto " style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="text-center">
                                    <button className={classes.button} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        <button className={classes.button} onClick={this.AddSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} `} style={{ minWidth: '70px' }} onClick={this.AddCancel1} ><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">Add New Matrix Of Materials-Disposition</h6>}
                        <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right m-0 d-flex"}>Material&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.Error.MaterialError ?
                                        <div className="autocomplete-wrappers">
                                            <Autocomplete
                                                contentEditable={true}
                                                value={this.state.addData.Material}
                                                inputProps={{
                                                    placeholder: "Material",
                                                }}
                                                items={MASTERDATA_MATERIAL ?? []}
                                                getItemValue={(item) => item.Name}
                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                renderMenu={(item) => (
                                                    <div className="dropdowns d-block" >{item}</div>
                                                )}

                                                renderInput={(props) => {
                                                    return (
                                                        <input
                                                            className="form-control border-radius"
                                                            id="exampleFormControlInput1"
                                                            {...props}
                                                            fullWidth
                                                            style={{ width: '100%', height: 35, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                        />
                                                    );
                                                }}

                                                renderItem={(item, isHighlighted) => (
                                                    <div
                                                        className={`items 
                 ${isHighlighted ? "selected-items" : ""
                                                            }`}
                                                    >
                                                        {item.Name}
                                                    </div>
                                                )}
                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                            />

                                        </div>
                                        :

                                        <div className="autocomplete-wrappers">
                                            <Autocomplete
                                                contentEditable={true}
                                                value={this.state.addData.Material}
                                                inputProps={{
                                                    placeholder: "Material",
                                                }}
                                                items={MASTERDATA_MATERIAL ?? []}
                                                getItemValue={(item) => item.Name}
                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                renderMenu={(item) => (
                                                    <div className="dropdowns d-block" >{item}</div>
                                                )}
                                                renderInput={(props) => {
                                                    return (
                                                        <input
                                                            className="form-control border-radius"
                                                            id="exampleFormControlInput1"
                                                            {...props}
                                                            style={{ height: 35, fontSize: 12, color: "#000000" }}
                                                        />
                                                    );
                                                }}
                                                renderItem={(item, isHighlighted) => (
                                                    <div
                                                        className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                            }`}
                                                    >
                                                        {item.Name}
                                                    </div>
                                                )}
                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                            />
                                        </div>
                                    }
                                </div>


                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right m-0 d-flex"}>Total Quantity in MT&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.Error.TotalError ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            placeholder="0.0"
                                            value={this.state.addData.TotalQuantity}
                                            onChange={(e) => { this.handleInputChange(e, "TotalQuantity") }}
                                            type="number"
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                maxLength: 20,
                                                minLength: 0,
                                                step: "0.1"
                                            }}
                                        />
                                        :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            placeholder="0.0"
                                            value={this.state.addData.TotalQuantity}
                                            onChange={(e) => { this.handleInputChange(e, "TotalQuantity") }}
                                            type="number"
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                maxLength: 20,
                                                minLength: 0,
                                                step: "0.1"
                                            }}
                                        />}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? " pt-2" : "float-end text-right"}>Reused in MT&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        type="number"
                                        placeholder="0.0"
                                        value={this.state.addData.ReusedInMT}
                                        onChange={(e) => { this.handleInputChange(e, "ReusedInMT") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            maxLength: 10,
                                            step: "1"
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? " pt-2" : "float-end text-right"}>Recycled in MT&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        placeholder="0.0"
                                        value={this.state.addData.RecycledInMT}
                                        onChange={(e) => { this.handleInputChange(e, "RecycledInMT") }} fullWidth
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            maxLength: 10,
                                            step: "1"
                                        }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? " pt-2" : "float-end text-right"}>Landfill in MT&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        fullWidth
                                        placeholder="0.0"
                                        value={this.state.addData.LandFillInMT}
                                        onChange={(e) => { this.handleInputChange(e, "LandFillInMT") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`,
                                            maxLength: 10,
                                            step: "1"
                                        }}
                                    />
                                </div>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex text-right m-0"}>Delivery&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.Error.DeliveryError ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.Delivery}
                                            onChange={(e) => { this.handleStringChange(e, "Delivery") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`,
                                                maxLength: 10,
                                                step: "1"
                                            }}
                                        /> : <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.Delivery}
                                            onChange={(e) => { this.handleStringChange(e, "Delivery") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" onClick={() => window.$("#cancelpopup").modal("hide")} class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        MOM_ListView: state.MOMReducer.MOM_ListView || [],
        MASTERDATA_MATERIAL: state.MasterDataReducer.Lookup_data || [],

    };
}

AddDROHM.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddDROHM))
);
